import React from 'react';
import sampleVideo from '../assests/no-internet.png';
import { useNetworkStatus } from './NetworkProvider';

function ErrorPage() {

   const { isOnline, serverReachable } = useNetworkStatus();
  return (
    <div>
      {!isOnline && (
          <div style={{ 
      position: 'relative',
       width: '100%',
        height: '100%',
         overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          borderRadius: '10px',
          boxShadow: '0 0 20px rgba(0, 0, 0, 0.5)',
          }}>
      <img 
        src={sampleVideo} 
        autoPlay 
        loop 
        muted 
        style={{
          width: '50%',
          height: '50%',
          objectFit: 'cover',

        }}
      />
      <div style={{ position: 'relative', zIndex: 1, color: 'white', textAlign: 'center' }}>
        <h2>Something went wrong! Check your internet connection.</h2>
      </div>
    </div>
      )}
      {!serverReachable && (
          <div style={{ 
      position: 'relative',
       width: '100%',
        height: '100%',
         overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          borderRadius: '10px',
          boxShadow: '0 0 20px rgba(0, 0, 0, 0.5)',
          }}>
      <img 
        src={sampleVideo} 
        autoPlay 
        loop 
        muted 
        style={{
          width: '50%',
          height: '50%',
          objectFit: 'cover',

        }}
      />
      <div style={{ position: 'relative', zIndex: 1, color: 'white', textAlign: 'center' }}>
        <h2>Something went wrong! Check your Server connection.</h2>
      </div>
    </div>
      )}
    </div>
  
  );
}

export default ErrorPage;
